<template>
  <BlockRepeater
    v-slot="slotProps"
    class="PlanningItem"
    title=""
    label="Voeg een stap toe"
    :path="path"
    :values="values"
    :disabled="disabled"
    :deleted="evaluateDeletedState"
  >
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :layout="layout"
      :disabled="disabled"
      :path="`${path}.${slotProps.id}`"
      :viewer="viewer"
    />
  </BlockRepeater>
</template>
<script>
import BlockRepeater from '@/components/form/BlockRepeater'
import FieldSet from '@/components/form/FieldSet'

export default {
  name: 'PlanningItem',
  components: { BlockRepeater, FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'Party',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Copied from Cafienne
      fields: {
        'PartyName': {
          'type': 'string',
          'title': 'Leverancier',
          'readonly': true,
        },
        'WorkDescription': {
          'type': 'string',
          'title': 'Beschrijving van de werkzaamheden',
          'format': 'textarea',
        },
        'IsPowerOut': {
          'type': 'boolean',
          // "title": "Stroom uit tijdens werkzaamheden?",
          'title': 'Stroom moet tijdens de werkzaamheden tijdelijk uitgeschakeld worden',
          // "description": "Mogelijk moet gedurende de werkzaamheden de stroom tijdelijk worden uitgeschakeld. Dit dient afgestemd te worden met de klant."
        },
        'ActualStartDate': {
          'type': 'string',
          'format': 'date',
          'title': 'Datum dat de werkzaamheden starten',
        },
        'ExpectedFinishDate': {
          'type': 'string',
          'format': 'date',
          'title': 'Verwachte einddatum werkzaamheden',
        },
        'ActualFinishDate': {
          'type': 'string',
          'format': 'date',
          'title': 'Daadwerkelijke einddatum werkzaamheden',
        },
        'deleted_at': {
          type: 'hidden',
        },
      },
      layout: [{
        'columns': '1fr 1fr',
        'fields': ['PartyName', 'IsPowerOut'],
      }, {
        'columns': '1fr 1fr 1fr',
        'fields': ['ActualStartDate', 'ExpectedFinishDate', 'ActualFinishDate'],
      }, {
        'columns': '1fr 0px',
        'fields': ['WorkDescription', 'deleted_at'],
      }],
    }
  },
  methods: {
    evaluateDeletedState({ index }) {
      return !! (
        this.values[this.path] && this.values[this.path][index] && this.values[this.path][index].deleted_at
      )
    },
  },
}
</script>
